import { render, staticRenderFns } from "./registerPartner.vue?vue&type=template&id=4426c5ef&scoped=true"
import script from "./registerPartner.vue?vue&type=script&lang=js"
export * from "./registerPartner.vue?vue&type=script&lang=js"
import style0 from "./registerPartner.vue?vue&type=style&index=0&id=4426c5ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4426c5ef",
  null
  
)

export default component.exports